module.exports = __webpack_public_path__ + "img/outlier.aeb4b699.jpg";